import { displayToast } from 'bundles/connect/helpers/display_toast';
import { updateProfile } from 'bundles/connect/helpers/prospect_api';
import type { NotificationPreferences } from 'bundles/connect/types';
import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap-5';

type Props = {
  notificationPreference: NotificationPreferences;
}

export default function NotificationSettings({ notificationPreference }: Props) {
  const [matchesDigestEmail, setMatchesDigestEmail] = useState(notificationPreference.matchesDigestEmail);
  const [matchesDigestSchedule, setMatchesDigestSchedule] = useState(notificationPreference.matchesDigestSchedule);
  const [offMarketPropertiesDigestEmail, setOffMarketPropertiesDigestEmail] =
    useState(notificationPreference.offMarketPropertiesDigestEmail);
  const [offMarketPropertiesDigestSchedule, setOffMarketPropertiesDigestSchedule] =
    useState(notificationPreference.offMarketPropertiesDigestSchedule);

  const onToggleMatchesDigestEmail = () => {
    updateProfile(
      { notificationPreferenceAttributes: { matchesDigestEmail: !matchesDigestEmail } }, 'saved_searches')
      .then(() => {
        setMatchesDigestEmail(!matchesDigestEmail);
        displayToast('Profile updated', 'success');
      });
  };

  const onToggleOffMarketPropertiesDigestEmail = () => {
    updateProfile(
      {
        notificationPreferenceAttributes: {
          offMarketPropertiesDigestEmail: !offMarketPropertiesDigestEmail
        }
      }, 'saved_searches')
      .then(() => {
        setOffMarketPropertiesDigestEmail(!offMarketPropertiesDigestEmail);
        displayToast('Profile updated', 'success');
      });
  };

  const onMatchesDigestScheduleChange = (e) => {
    const schedule = e.target.value;
    updateProfile(
      { notificationPreferenceAttributes: { matchesDigestSchedule: schedule } }, 'saved_searches')
      .then(() => {
        setMatchesDigestSchedule(schedule);
        displayToast('Profile updated', 'success');
      });
  };

  const onOffMarketPropertiesDigestScheduleChange = (e) => {
    const schedule = e.target.value;
    updateProfile(
      { notificationPreferenceAttributes: { offMarketPropertiesDigestSchedule: schedule } }, 'saved_searches')
      .then(() => {
        setOffMarketPropertiesDigestSchedule(schedule);
        displayToast('Profile updated', 'success');
      });
  };

  return (
    <>
      <Card.Header className="p-6">
        <Row className="p-0">
          <Col><h4 className="my-0">Notifications Settings</h4></Col>
        </Row>
      </Card.Header>
      <Card.Body className="p-6">
        <Row className="align-items-center justify-content-between p-4 border rounded-top">
          <Col>
            <div className="d-flex align-items-center gap-2">
              <div className="form-check form-switch verbose">
                <input
                  checked={matchesDigestEmail}
                  className="form-check-input"
                  id="toggle_matches_digest_email"
                  role="switch"
                  type="checkbox"
                  onChange={onToggleMatchesDigestEmail}
                />
                <label className="inner-label" htmlFor="toggle_matches_digest_email">
                  <span className="position-absolute indicator on-indicator">ON</span>
                  <span className="position-absolute indicator off-indicator">OFF</span>
                </label>
              </div>
              <div className="fw-bolder">Exclusive Listing Updates</div>
            </div>
          </Col>
          <Col xs="auto">
            <Form.Group className="d-flex align-items-center gap-2">
              <Form.Label className="mb-0">Frequency</Form.Label>
              <Form.Select
                disabled={!matchesDigestEmail}
                size="lg"
                value={matchesDigestSchedule}
                onChange={onMatchesDigestScheduleChange}
              >
                <option value="daily">Daily</option>
                <option value="semiweekly">Semiweekly</option>
                <option value="weekly">Weekly</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-between p-4 border border-top-0 rounded-bottom">
          <Col>
            <div className="d-flex align-items-center gap-2">
              <div className="form-check form-switch verbose">
                <input
                  checked={offMarketPropertiesDigestEmail}
                  className="form-check-input"
                  id="toggle_off_market_digest_email"
                  role="switch"
                  type="checkbox"
                  onChange={onToggleOffMarketPropertiesDigestEmail}
                />
                <label className="inner-label" htmlFor="toggle_off_market_digest_email">
                  <span className="position-absolute indicator on-indicator">ON</span>
                  <span className="position-absolute indicator off-indicator">OFF</span>
                </label>
              </div>
              <div className="fw-bolder">Saved Searches Updates</div>
            </div>
          </Col>
          <Col xs="auto">
            <Form.Group className="d-flex align-items-center gap-2">
              <Form.Label className="mb-0">Frequency</Form.Label>
              <Form.Select
                disabled={!offMarketPropertiesDigestEmail}
                size="lg"
                value={offMarketPropertiesDigestSchedule}
                onChange={onOffMarketPropertiesDigestScheduleChange}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
}
